import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'

import { cn } from '@/lib/utils'
import { getHubTheme } from '@/constants/hubs'

interface HubCardProps {
    slug: string
    name: string
    description: string
    count: number
}

export const HubCard: FC<HubCardProps> = ({ slug, name, description, count }): ReactNode => {
    const theme = getHubTheme(slug)
    const Icon = theme.icon

    return (
        <Link
            href={`/${slug}`}
            className={cn(
                'group relative flex flex-col rounded-2xl border bg-card p-6 transition-all hover:-translate-y-0.5 hover:shadow-md',
                theme.border
            )}
        >
            <div className={cn('flex size-12 items-center justify-center rounded-xl', theme.softBg)}>
                <Icon className={cn('size-6', theme.ink)} />
            </div>

            <h3
                className='mt-5 font-heading text-xl font-semibold tracking-tight'
                data-mdlfy-cms={`hubs:${slug}:name`}
            >
                {name}
            </h3>

            <p
                className='mt-2 flex-1 text-sm leading-relaxed text-muted-foreground'
                data-mdlfy-cms={`hubs:${slug}:description`}
            >
                {description}
            </p>

            <span className={cn('mt-5 inline-flex items-center gap-1.5 text-sm font-semibold', theme.ink)}>
                Explore <span>{count}</span> {count === 1 ? 'article' : 'articles'}
                <ArrowRight className='size-4 transition-transform group-hover:translate-x-0.5' />
            </span>
        </Link>
    )
}
